<template>
  <div class="variants">
    <Button
      v-for="variant in outOfStockVariants"
      :key="variant.id"
      width="full"
      theme="outline"
      class="variant"
      :class="{
        'variant--selected': selectedVariant?.id === variant.id,
      }"
      @click="handleVariantSelect(variant)"
    >
      {{ variant.title }}
    </Button>
  </div>
</template>

<script>
import Button from "@/components/ButtonV3.vue";

import { mapGetters } from "vuex";

export default {
  name: "OutOfStockVariants",
  components: {
    Button,
  },
  emits: ["change"],
  data() {
    return {
      selectedVariant: null,
    };
  },
  computed: {
    ...mapGetters("product", ["variants"]),
    outOfStockVariants() {
      return this.variants.filter((variant) => {
        return !(variant.quantityAvailable > 0 && variant.availableForSale);
      });
    },
  },
  methods: {
    handleVariantSelect(variant) {
      this.selectedVariant = variant;
      this.$emit("change", variant);
    },
  },
};
</script>

<style lang="scss" scoped>
.variants {
  display: flex;
  gap: 10px;
  justify-content: start;
  flex-flow: row wrap;

  & > * {
    flex: 0 0 50px;
  }
}

.variant {
  &--selected {
    background-color: $color-black;
    color: $color-white;
  }
}
</style>
